import type { DecisioningStudioWizardAllowedArgs } from "./types";

/**
 * The wizard's own audience: the self-serve agent flipper plus edit rights or impersonation, so
 * editing a Go agent rolls out with creating one. Shared by the edit URL's navigation gate and the
 * page that re-checks it before rendering the wizard.
 */
export const getDecisioningStudioWizardAllowed = ({
  featureOn,
  hasPermission,
  isImpersonating,
}: DecisioningStudioWizardAllowedArgs): boolean =>
  featureOn("decisioning_studio_add_agent") &&
  (isImpersonating || hasPermission("appGroup", { permission: "editDecisioningStudioAgents" }));
